"use strict";
exports.__esModule = true;
var checksum_1 = require("@iota/checksum");
var Promise = require("bluebird");
var errors = require("../../errors");
var guards_1 = require("../../guards");
var types_1 = require("../../types");
exports.createWereAddressesSpentFrom = function (_a, caller) {
    var send = _a.send;
    return function (addresses, callback) {
        if (caller !== 'lib') {
            /* tslint:disable-next-line:no-console */
            console.warn('Avoid using `wereAddressesSpentFrom()` instead of proper input management with a local database.\n' +
                '`wereAddressesSpentFrom()` does not scale in IoT environment, hence it will be removed from the ' +
                'library in a future version.');
        }
        return Promise.resolve(guards_1.validate(guards_1.arrayValidator(guards_1.hashValidator)(addresses, errors.INVALID_ADDRESS)))
            .then(function () {
            return send({
                command: types_1.IRICommand.WERE_ADDRESSES_SPENT_FROM,
                addresses: addresses.map(checksum_1.removeChecksum)
            });
        })
            .then(function (res) { return res.states; })
            .asCallback(callback);
    };
};
//# sourceMappingURL=createWereAddressesSpentFrom.js.map